module.exports = __webpack_public_path__ + "img/solarroof.e03b299.webp";